const types = {
  SMS_START: 'SMS_START',
  SMS_SUCCESS: 'SMS_SUCCESS',
  SMS_FAILURE: 'SMS_FAILURE',
  GET_SMS_START: 'GET_SMS_START',
  GET_SMS_SUCCESS: 'GET_SMS_SUCCESS',
  GET_SMS_FAILURE: 'GET_SMS_FAILURE',
  GET_MESSAGES_TEMPLATES_START: 'GET_MESSAGES_TEMPLATES_START',
  GET_MESSAGES_TEMPLATES_SUCCESS: 'GET_MESSAGES_TEMPLATES_SUCCESS',
  GET_MESSAGES_TEMPLATES_FAILURE: 'GET_MESSAGES_TEMPLATES_FAILURE',
  ADD_MESSAGES_START: 'ADD_MESSAGES_START',
  ADD_MESSAGES_SUCCESS: 'ADD_MESSAGES_SUCCESS',
  ADD_MESSAGES_FAILURE: 'ADD_MESSAGES_FAILURE',
  EDIT_MESSAGES_START: 'EDIT_MESSAGES_START',
  EDIT_MESSAGES_SUCCESS: 'EDIT_MESSAGES_SUCCESS',
  EDIT_MESSAGES_FAILURE: 'EDIT_MESSAGES_FAILURE',
  DELETE_MESSAGES_START: 'DELETE_MESSAGES_START',
  DELETE_MESSAGES_SUCCESS: 'DELETE_MESSAGES_SUCCESS',
  DELETE_MESSAGES_FAILURE: 'DELETE_MESSAGES_FAILURE',
};
export default types;
